import React from "react";
import {Alert} from "@aws-amplify/ui-react";
import styles from './index.module.css'

const GlobalAlert = ({heading = "", variation = "info", style = {}}) => {
  return (
    <Alert
      hasIcon
      isDismissible
      heading={heading}
      variation={variation}
      className={styles.globalAlert}
      style={style}
    />
  )
}

export default GlobalAlert;